import axios from "axios";
import { createContext, useEffect, useState } from "react";

axios.defaults.baseURL = "/api"

export const AuthContext = createContext();

export const AuthContexProvider = ({ children }) => {

  const [currentUser, setCurrentUser] = useState(
    sessionStorage.getItem("user_token") || null
    // localStorage.getItem("user_token") || null
  );

  const login = async (inputs) => {
    const res = await axios.post("/auth/login", inputs);
    setCurrentUser(res.data.token);
  };

  useEffect(() => {
    if (currentUser) {
      sessionStorage.setItem("user_token", currentUser);
    } else {
      sessionStorage.removeItem("user_token");
    }
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, login }}>
      {children}
    </AuthContext.Provider>
  );
  
};
